import { classNames } from "@helpers/css";

import { emptyRoleColWidth } from "../helpers";

const EmptyCriteriaCell = ({ isLastRow }: { isLastRow?: boolean }) => (
  <td
    className={classNames(
      emptyRoleColWidth,
      "p-4 border align-center text-center align-middle bg-gray-50 text-gray-300",
      isLastRow && "border-b-0",
    )}
  >
    No role
  </td>
);

export default EmptyCriteriaCell;
